module.exports = __webpack_public_path__ + "resources/img/img_secuwayssl_vvpn_m.0639e797ec37ecd0ef7e1039b44c3cc1.png";